import { Box, Tooltip, Typography } from "@mui/material";
import { useIntl } from "react-intl";
import Messages from "../../../../../localization/Messages";
import ChartComponent from "../../ChartComponent/ChartComponent";
import { ExpenseStatsDock } from "../../../../../models/stats";
import { IDock } from "../../../../../models/dock";
import { formatNumber } from "../../../../../helpers/numberDisplayHelper";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

type ConsumptionAnalyticsProps = {
    expenseStatsDock: ExpenseStatsDock[];
    docks: IDock[];
};

export const ConsumptionAnalytics = ({ expenseStatsDock, docks }: ConsumptionAnalyticsProps) => {
    const intl = useIntl();
    const dataAvailable = expenseStatsDock.length > 0;
    const totals = dataAvailable
        ? expenseStatsDock.reduce(
              (acc, dock) => {
                  acc.totalWaterCost += dock.waterCost;
                  acc.totalElectricityCost += dock.electricityCost;
                  return acc;
              },
              {
                  totalWaterCost: 0,
                  totalElectricityCost: 0,
              },
          )
        : {
              totalWaterCost: 0,
              totalElectricityCost: 0,
          };

    const { totalWaterCost, totalElectricityCost } = totals;

    return (
        <Box className="consumption-analytics-container shadow" my={2} mx={2.5} padding={2.5}>
            <Typography variant="h5">
                {intl.formatMessage(Messages.consumption)}
                <Tooltip title={intl.formatMessage(Messages.onlyInvoicedConfirmedChangedTooltip)}>
                    <HelpOutlineIcon fontSize="small" color="action" />
                </Tooltip>
            </Typography>

            <Box display="flex" gap={1} width={"100%"}>
                <Box width={"50%"}>
                    <ChartComponent
                        data={
                            dataAvailable
                                ? expenseStatsDock.map(stat => {
                                      return {
                                          label: docks.find(d => d.id === stat.id)?.name ?? "",
                                          value: stat.waterCost,
                                      };
                                  })
                                : []
                        }
                        description={intl.formatMessage(
                            Messages.totalAmmountOfWaterConsumptionByDock,
                        )}
                        outerStats={[
                            `${intl.formatMessage(
                                Messages.totalAmountOfWaterConsumption,
                            )} = CHF ${formatNumber(totalWaterCost)}`,
                        ]}
                        formatter={value =>
                            `${formatNumber(value)} / ${((value / totalWaterCost) * 100).toFixed(
                                2,
                            )}%`
                        }
                    />
                </Box>

                <Box width={"50%"}>
                    <ChartComponent
                        data={
                            dataAvailable
                                ? expenseStatsDock.map(stat => {
                                      return {
                                          label: docks.find(d => d.id === stat.id)?.name ?? "",
                                          value: stat.electricityCost,
                                      };
                                  })
                                : []
                        }
                        description={intl.formatMessage(
                            Messages.totalAmmountOfElectricityConsumptionByDock,
                        )}
                        outerStats={[
                            `${intl.formatMessage(
                                Messages.totalAmountOfElectricityConsumption,
                            )} = CHF ${formatNumber(totalElectricityCost)}`,
                        ]}
                        formatter={value =>
                            `${formatNumber(value)} / ${(
                                (value / totalElectricityCost) *
                                100
                            ).toFixed(2)}%`
                        }
                    />
                </Box>
            </Box>
        </Box>
    );
};
